import { KeyType } from '@/components/ScoresheetTables/common/types';

export const POINTS_TABLE_KEYS: KeyType[] = [
  'pointsOffTurnovers',
  'secondChancePoints',
  'benchPoints',
];
